import { PayloadAction,createSlice } from "@reduxjs/toolkit";
import { BankAccounts } from "../../types/bankAccount";

interface RootState{
    bankaccount:BankAccounts[] ;
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
    currentPage: number;
    totalPages: number;
    totalCount: number;
    pageSize: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}
const initialState: RootState = {
    bankaccount: [],
    status: 'idle',
    error: null,
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
  };


export const BankAccountSlice = createSlice({
    name: "bankaccount",
    initialState,
    reducers: {
      SetBankAccount: (state, action: PayloadAction<BankAccounts[]>) => {
        state.status = 'succeeded';
        state.bankaccount = action.payload;
        state.error = null;
      },
      AddBankAccount: (state, action: PayloadAction<BankAccounts>) => {
        state.bankaccount?.push(action.payload);
        state.status = 'succeeded';
        state.error = null;
      },
      GetBankAccount:(state,action:PayloadAction<BankAccounts[]>)=>{
        state.bankaccount=action.payload;
        state.status='succeeded';
        state.error=null;
      },
      UpdateBankAccount: (state, action: PayloadAction<BankAccounts>) => {
        if (Array.isArray(state.bankaccount)) {
          const index = state.bankaccount.findIndex((e) => e.id === action.payload.id);
          if (index !== -1) {
            state.bankaccount[index] = action.payload;
          }
        }
        state.status = 'succeeded';
        state.error = null;
      },      
      BankAccountDelete: (state, action: PayloadAction<string>) => {
        if (!Array.isArray(state.bankaccount)) {
            state.bankaccount = [];
        }
        const index = state.bankaccount.findIndex((c) => c.id === action.payload);
        if (index !== -1) {
            state.bankaccount.splice(index, 1);
        }
        state.status = 'succeeded';
        state.error = null;
    },
    }
  })
  
  export const { SetBankAccount, AddBankAccount,GetBankAccount,UpdateBankAccount,BankAccountDelete } = BankAccountSlice.actions;
  export default BankAccountSlice.reducer;
  
